export const REQUEST_ENDPOINT =
  "https://hooks.zapier.com/hooks/catch/9615379/3zz8xgb/";

export const CATALOG_URL =
  "https://landing-linetex.s3.us-west-2.amazonaws.com/static/media/linetex-2021.pdf";
